import {
  EnvironmentProviders,
  Injectable,
  makeEnvironmentProviders,
  provideAppInitializer,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Rum, RumConfig } from './rum';

@Injectable({ providedIn: 'root' })
export class RumProvider {
  static provide(config: RumConfig): EnvironmentProviders {
    return makeEnvironmentProviders([
      provideAppInitializer(() => {
        const platformId = inject(PLATFORM_ID);
        if (!isPlatformBrowser(platformId)) return; // SSR-safe
        const svc = inject(Rum);
        return svc.init(config);
      }),
    ]);
  }
}
